import React from 'react';
import { ChevronRight } from 'lucide-react';
export function FascinationsSection() {
  const bullets = [{
    title: 'El "Error de las 8 AM":',
    text: <span data-id="element-38">
          Por qué ese desayuno "saludable" que te recomendaron es lo que te{' '}
          <strong className="text-background" data-id="element-39">
            garantiza tener hambre a las 11
          </strong>
          .
        </span>
  }, {
    title: 'La Bóveda de Energía:',
    text: <span data-id="element-40">
          El secreto biológico para obligar a tu cuerpo a{' '}
          <strong className="text-background" data-id="element-41">
            quemar lo que tiene guardado en la cintura
          </strong>
          , sin que vos se lo pidas.
        </span>
  }, {
    title: 'El Interruptor de la Claridad:',
    text: <span data-id="element-42">
          Cómo limpiar la{' '}
          <strong className="text-background" data-id="element-43">neuro-inflamación</strong> que te
          hace sentir <strong className="text-amber" data-id="element-44">"atontado"</strong> durante
          el día (Página 14).
        </span>
  }, {
    title: 'El Protocolo de Emergencia de 72 horas:',
    text: <span data-id="element-45">
          Qué hacer exactamente durante los primeros{' '}
          <strong className="text-background" data-id="element-46">3 días</strong> para que tu{' '}
          <strong className="text-background" data-id="element-47">
            ropa empiece a sentirse más suelta
          </strong>
          .
        </span>
  }];
  return <section className="py-4 md:py-14 px-6 bg-navy text-background" data-id="element-48">
      <div className="max-w-4xl mx-auto" data-id="element-49">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-12 text-center leading-tight" data-id="element-50">
          Lo que <span className="text-amber" data-id="element-51">nadie te cuenta</span> y que vas a
          descubrir en minutos:
        </h2>

        <div className="space-y-6" data-id="element-52">
          {bullets.map((bullet, index) => <div key={index} className="flex items-start gap-4 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-53">
              <div className="mt-1 flex-shrink-0" data-id="element-54">
                <ChevronRight className="w-6 h-6 text-amber" data-id="element-55" />
              </div>
              <p className="text-lg md:text-xl leading-relaxed" data-id="element-56">
                <strong className="text-amber font-semibold" data-id="element-57">
                  {bullet.title}
                </strong>{' '}
                {bullet.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}